import { isString } from "lodash";
import { instance } from "../store/utils";

const notAWarning = message => {
  return (
    (Array.isArray(message) &&
      (isString(message[0]) && !message?.[0]?.startsWith("Warning"))) ||
    (isString(message) && !message?.startsWith("Warning"))
  );
};

export const logToServer = (log, type = "info") => {

  instance
    .post(
      "/api/logger/",
      { text: log, type },
      {
        headers: {
          "Cache-Control": "no-cache"
        }
      }
    )
    .then()
    .catch(err => {
        console.debug("Logger Error:", err?.response?.data, ", Status:", err?.response?.status);
    });
};

export const overrideConsoleMethods = () => {
  const originalConsoleLog = console.log;
  const originalConsoleError = console.error;
  const originalConsoleInfo = console.info;

  console.log = function (...args) {
    const logText = [...args];
    try {
      if (notAWarning(logText)) logToServer([...args], "info");
    } catch (e) {
      console.error(e);
    }
    originalConsoleLog.apply(console, args);
  };

  console.error = function (...args) {
    const logText = [...args];
    try {
      if (notAWarning(logText)) logToServer([...args], "error");
    } catch (e) {
      console.debug(e);
    }
    originalConsoleError.apply(console, args);
  };

  console.info = function (...args) {
    const logText = [...args];
    try {
      if (notAWarning(logText)) logToServer([...args], "info");
    } catch (e) {
      console.debug(e);
    }
    originalConsoleInfo.apply(console, args);
  };
};
